import { PostOrderAddressAdapter } from '../infra/adapters/postOrderAddress.adapter';
import { PostOrderAddressService } from '../application/services/PostOrderAddressService';

export const buildPostOrderAddress = () => {
  const repository = new PostOrderAddressAdapter();
  const service = new PostOrderAddressService(repository);
  
  return { service };
};